// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Estils específics de la pestanya "Calendari" de Gestió d'un Empleat.
   Totes les classes van prefixades amb "calendari-emp-" perquè no afectin
   cap altra pantalla: per revertir-ho n'hi ha prou en eliminar aquest
   fitxer i el seu import a CalendariEmpleat.js.

   El vermell de Festiu reutilitza el mateix to que calendarilaboral.css
   (#d9534f), tal com demana CURRENT_TASK.md punt 11 ("vermell de sistema").
   Cada dia marca el seu "tipus de dia" (Festiu/No laborable/Laborable) amb
   una vora de color i les Absències/Baixes amb xips, sense pintar mai tota
   la cel·la amb un únic color (punt 10). */

.calendari-emp-vista-selector {
  display: flex;
  gap: 4px;
  margin-bottom: 8px;
}

.calendari-emp-vista-selector button {
  padding: 5px 14px;
  font-size: 13px;
  font-weight: bold;
  border: 1px solid #ccc;
  border-radius: 4px 4px 0 0;
  background: #f1f1f1;
  cursor: pointer;
  transition: background-color 0.2s;
}

.calendari-emp-vista-selector button:hover {
  background: #e0e0e0;
}

.calendari-emp-vista-selector button.active {
  background: #fff;
  border-bottom: 2px solid #fff;
  color: #0078d7;
}

.calendari-emp-nav {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 6px 0 10px;
}

.calendari-emp-titol-mes {
  font-size: 18px;
  font-weight: 700;
  min-width: 160px;
  text-align: center;
}

.calendari-emp-accions {
  display: flex;
  gap: 8px;
  margin-bottom: 14px;
}

/* --- Vista "Any complet": graella dels 12 mesos --- */
.calendari-emp-any-graella {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 16px;
}

.calendari-emp-mes-bloc-petit {
  background-color: var(--dv2-surface, #ffffff);
  border: 1px solid var(--dv2-border, #ddd);
  border-radius: var(--dv2-radius, 8px);
  padding: 10px;
  box-shadow: var(--dv2-shadow, none);
}

.calendari-emp-mes-titol {
  font-weight: 700;
  text-align: center;
  margin-bottom: 6px;
  font-size: 13px;
}

/* --- Graella (comuna a vista Mes i vista Any) --- */
.calendari-emp-dies-setmana,
.calendari-emp-graella {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 2px;
}

.calendari-emp-mes-bloc-petit .calendari-emp-dies-setmana,
.calendari-emp-mes-bloc-petit .calendari-emp-graella {
  gap: 2px;
}

.calendari-emp-dia-setmana {
  font-size: 11px;
  font-weight: 700;
  text-align: center;
  color: var(--dv2-text-muted, #777);
}

.calendari-emp-dia {
  min-height: 72px;
  border: 1px solid #e2e2e2;
  border-left: 4px solid #e2e2e2;
  border-radius: 6px;
  padding: 4px;
  background-color: #fff;
}

.calendari-emp-dia-buit {
  border: none;
  background: transparent;
}

.calendari-emp-dia-num {
  font-size: 12px;
  font-weight: 700;
  color: #334155;
}

/* --- Cel·la compacta (vista "Any complet"): mida reduïda, punts de color en
   comptes de xips de text, perquè hi càpiguen els 12 mesos alhora. --- */
.calendari-emp-dia-petit {
  min-height: 0;
  font-size: 12px;
  padding: 4px 0;
  text-align: center;
  border-radius: 4px;
  border-width: 0 0 0 3px;
}

.calendari-emp-dia-petit .calendari-emp-dia-num {
  font-size: 12px;
  font-weight: 700;
}

.calendari-emp-dia-punts {
  display: flex;
  flex-wrap: wrap;
  gap: 2px;
  margin-top: 2px;
}

.calendari-emp-punt {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
}

.calendari-emp-dia-laborable {
  border-left-color: #6690e0;
}

.calendari-emp-dia-no-laborable {
  background-color: #f4f4f4;
  border-left-color: #bbbbbb;
}

/* Fora de vigència (abans de l'Alta / després de la Baixa): gris més fosc i
   ratllat perquè es distingeixi clarament d'un simple dia no laborable com
   un cap de setmana (CURRENT_TASK_RECTIFICATIU_VIGENCIA_EMPLEAT.md §9.1). */
.calendari-emp-dia-fora-vigencia {
  background-color: #e2e2e2;
  background-image: repeating-linear-gradient(45deg, rgba(0, 0, 0, 0.04) 0, rgba(0, 0, 0, 0.04) 6px, transparent 6px, transparent 12px);
  border-left-color: #9e9e9e;
  color: #999;
}

.calendari-emp-dia-festiu {
  border-left-color: #d9534f;
  background-color: #fdecea;
}

/* Festius d'Empresa (TipusFestiu = EMPRESA): blau corporatiu, diferenciat
   dels festius oficials (CURRENT_TASK_CALENDARI_I_COMPUTS.md §5). */
.calendari-emp-dia-festiu-empresa {
  border-left-color: #0099cc;
  background-color: #e6f6fc;
}

.calendari-emp-dia-xips {
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-top: 3px;
}

.calendari-emp-xip {
  display: inline-block;
  font-size: 10px;
  line-height: 1.4;
  color: #fff;
  padding: 0 4px;
  border-radius: 3px;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.calendari-emp-xip-mes {
  font-size: 10px;
  color: #777;
}

.calendari-emp-llegenda {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  margin-top: 14px;
  padding: 8px;
  background: #f4f4f9;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  font-size: 12px;
}

.calendari-emp-llegenda-item {
  display: flex;
  align-items: center;
  gap: 5px;
}

.calendari-emp-llegenda-quadre {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 3px;
  border: 1px solid #ccc;
}

.calendari-emp-llegenda-festiu {
  background-color: #d9534f;
  border-color: #d9534f;
}

.calendari-emp-llegenda-festiu-empresa {
  background-color: #0099cc;
  border-color: #0099cc;
}

.calendari-emp-llegenda-no-laborable {
  background-color: #f4f4f4;
  border-color: #bbbbbb;
}

.calendari-emp-llegenda-fora-vigencia {
  background-color: #e2e2e2;
  border-color: #9e9e9e;
}

.calendari-emp-error {
  color: #d9534f;
  font-weight: bold;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/calendariempleat.css"],"names":[],"mappings":"AAAA;;;;;;;;;2CAS2C;;AAE3C;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA,uDAAuD;AACvD;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,6CAA6C;EAC7C,yCAAyC;EACzC,qCAAqC;EACrC,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,qDAAqD;AACrD;;EAEE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA;;EAEE,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;yEACyE;AACzE;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;;4EAE4E;AAC5E;EACE,yBAAyB;EACzB,qIAAqI;EACrI,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;oEACoE;AACpE;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB","sourcesContent":["/* Estils específics de la pestanya \"Calendari\" de Gestió d'un Empleat.\n   Totes les classes van prefixades amb \"calendari-emp-\" perquè no afectin\n   cap altra pantalla: per revertir-ho n'hi ha prou en eliminar aquest\n   fitxer i el seu import a CalendariEmpleat.js.\n\n   El vermell de Festiu reutilitza el mateix to que calendarilaboral.css\n   (#d9534f), tal com demana CURRENT_TASK.md punt 11 (\"vermell de sistema\").\n   Cada dia marca el seu \"tipus de dia\" (Festiu/No laborable/Laborable) amb\n   una vora de color i les Absències/Baixes amb xips, sense pintar mai tota\n   la cel·la amb un únic color (punt 10). */\n\n.calendari-emp-vista-selector {\n  display: flex;\n  gap: 4px;\n  margin-bottom: 8px;\n}\n\n.calendari-emp-vista-selector button {\n  padding: 5px 14px;\n  font-size: 13px;\n  font-weight: bold;\n  border: 1px solid #ccc;\n  border-radius: 4px 4px 0 0;\n  background: #f1f1f1;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.calendari-emp-vista-selector button:hover {\n  background: #e0e0e0;\n}\n\n.calendari-emp-vista-selector button.active {\n  background: #fff;\n  border-bottom: 2px solid #fff;\n  color: #0078d7;\n}\n\n.calendari-emp-nav {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 6px 0 10px;\n}\n\n.calendari-emp-titol-mes {\n  font-size: 18px;\n  font-weight: 700;\n  min-width: 160px;\n  text-align: center;\n}\n\n.calendari-emp-accions {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 14px;\n}\n\n/* --- Vista \"Any complet\": graella dels 12 mesos --- */\n.calendari-emp-any-graella {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n  gap: 16px;\n}\n\n.calendari-emp-mes-bloc-petit {\n  background-color: var(--dv2-surface, #ffffff);\n  border: 1px solid var(--dv2-border, #ddd);\n  border-radius: var(--dv2-radius, 8px);\n  padding: 10px;\n  box-shadow: var(--dv2-shadow, none);\n}\n\n.calendari-emp-mes-titol {\n  font-weight: 700;\n  text-align: center;\n  margin-bottom: 6px;\n  font-size: 13px;\n}\n\n/* --- Graella (comuna a vista Mes i vista Any) --- */\n.calendari-emp-dies-setmana,\n.calendari-emp-graella {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 2px;\n}\n\n.calendari-emp-mes-bloc-petit .calendari-emp-dies-setmana,\n.calendari-emp-mes-bloc-petit .calendari-emp-graella {\n  gap: 2px;\n}\n\n.calendari-emp-dia-setmana {\n  font-size: 11px;\n  font-weight: 700;\n  text-align: center;\n  color: var(--dv2-text-muted, #777);\n}\n\n.calendari-emp-dia {\n  min-height: 72px;\n  border: 1px solid #e2e2e2;\n  border-left: 4px solid #e2e2e2;\n  border-radius: 6px;\n  padding: 4px;\n  background-color: #fff;\n}\n\n.calendari-emp-dia-buit {\n  border: none;\n  background: transparent;\n}\n\n.calendari-emp-dia-num {\n  font-size: 12px;\n  font-weight: 700;\n  color: #334155;\n}\n\n/* --- Cel·la compacta (vista \"Any complet\"): mida reduïda, punts de color en\n   comptes de xips de text, perquè hi càpiguen els 12 mesos alhora. --- */\n.calendari-emp-dia-petit {\n  min-height: 0;\n  font-size: 12px;\n  padding: 4px 0;\n  text-align: center;\n  border-radius: 4px;\n  border-width: 0 0 0 3px;\n}\n\n.calendari-emp-dia-petit .calendari-emp-dia-num {\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.calendari-emp-dia-punts {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 2px;\n  margin-top: 2px;\n}\n\n.calendari-emp-punt {\n  display: inline-block;\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n}\n\n.calendari-emp-dia-laborable {\n  border-left-color: #6690e0;\n}\n\n.calendari-emp-dia-no-laborable {\n  background-color: #f4f4f4;\n  border-left-color: #bbbbbb;\n}\n\n/* Fora de vigència (abans de l'Alta / després de la Baixa): gris més fosc i\n   ratllat perquè es distingeixi clarament d'un simple dia no laborable com\n   un cap de setmana (CURRENT_TASK_RECTIFICATIU_VIGENCIA_EMPLEAT.md §9.1). */\n.calendari-emp-dia-fora-vigencia {\n  background-color: #e2e2e2;\n  background-image: repeating-linear-gradient(45deg, rgba(0, 0, 0, 0.04) 0, rgba(0, 0, 0, 0.04) 6px, transparent 6px, transparent 12px);\n  border-left-color: #9e9e9e;\n  color: #999;\n}\n\n.calendari-emp-dia-festiu {\n  border-left-color: #d9534f;\n  background-color: #fdecea;\n}\n\n/* Festius d'Empresa (TipusFestiu = EMPRESA): blau corporatiu, diferenciat\n   dels festius oficials (CURRENT_TASK_CALENDARI_I_COMPUTS.md §5). */\n.calendari-emp-dia-festiu-empresa {\n  border-left-color: #0099cc;\n  background-color: #e6f6fc;\n}\n\n.calendari-emp-dia-xips {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  margin-top: 3px;\n}\n\n.calendari-emp-xip {\n  display: inline-block;\n  font-size: 10px;\n  line-height: 1.4;\n  color: #fff;\n  padding: 0 4px;\n  border-radius: 3px;\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.calendari-emp-xip-mes {\n  font-size: 10px;\n  color: #777;\n}\n\n.calendari-emp-llegenda {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 14px;\n  margin-top: 14px;\n  padding: 8px;\n  background: #f4f4f9;\n  border: 1px solid #e0e0e0;\n  border-radius: 6px;\n  font-size: 12px;\n}\n\n.calendari-emp-llegenda-item {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.calendari-emp-llegenda-quadre {\n  display: inline-block;\n  width: 12px;\n  height: 12px;\n  border-radius: 3px;\n  border: 1px solid #ccc;\n}\n\n.calendari-emp-llegenda-festiu {\n  background-color: #d9534f;\n  border-color: #d9534f;\n}\n\n.calendari-emp-llegenda-festiu-empresa {\n  background-color: #0099cc;\n  border-color: #0099cc;\n}\n\n.calendari-emp-llegenda-no-laborable {\n  background-color: #f4f4f4;\n  border-color: #bbbbbb;\n}\n\n.calendari-emp-llegenda-fora-vigencia {\n  background-color: #e2e2e2;\n  border-color: #9e9e9e;\n}\n\n.calendari-emp-error {\n  color: #d9534f;\n  font-weight: bold;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
